<h1 mat-dialog-title class="editHeader text-center blueHeader dialogHeader text-white">{{headerTitle}}</h1>
<mat-dialog-content class="mb-4">
  <div class="mt-3">
    <div class="col-md-12 mb-1">
      <label class="payingClinic col-md-6 text-bold">Clinic Name: </label>
      <label class="payingClinic col-md-6">{{leadData?.clinic_name}}</label>
    </div>
    <div class="col-md-12 mb-1">
      <label class="payingClinic col-md-6 text-bold">First Name: </label>
      <label class="payingClinic col-md-6">{{leadData?.first_name}}</label>
    </div>
    <div class="col-md-12 mb-1">
      <label class="payingClinic col-md-6 text-bold">Last Name: </label>
      <label class="payingClinic col-md-6">{{leadData?.last_name}}</label>
    </div>
    <div class="col-md-12 mb-1">
      <label class="payingClinic col-md-6 text-bold">EmailId: </label>
      <label class="payingClinic col-md-6">{{leadData?.email_id}}</label>
    </div>
    <div class="col-md-12 mb-1">
      <label class="payingClinic col-md-6 text-bold">Mobile Number: </label>
      <label class="payingClinic col-md-6">{{leadData?.phone_no}}</label>
    </div>
    <div class="col-md-12 mb-1">
      <label class="payingClinic col-md-6 text-bold">Key Skills: </label>
      <label class="payingClinic col-md-6">{{leadData?.key_skills}}</label>
    </div>
    <div class="col-md-12 mb-1">
      <label class="payingClinic col-md-6 text-bold">Qualification: </label>
      <label class="payingClinic col-md-6">{{leadData?.qualification}}</label>
    </div>
    <div class="col-md-12 mb-1">
      <div class="payingClinic col-md-6 d-inline-block text-bold addressTxt">Address : </div>
      <div class="col-md-6 d-inline-block">
        <div class="payingClinic">{{leadData?.address?.address_line1}}</div>
        <div class="payingClinic" *ngIf="leadData.address.address_line2">{{leadData?.address?.address_line2}}</div>
        <div>
          <label class="payingClinic">{{leadData?.address?.city}}</label>,
          <label class="payingClinic">{{leadData?.address?.state}}</label> -
          <label class="payingClinic">{{leadData?.address?.pincode}}</label>
        </div>
      </div>
    </div>
    <div class="col-md-12 mb-1"
      *ngIf="isEditEnabled && leadData.status !== 'APPROVED' && leadData.status !== 'REJECTED'">
      <label for="status_change" class="payingClinic col-md-6">Plan:</label>
      <select name="status_change" class="form-control input-font name inputBox col-md-6" [(ngModel)]="plan">
        <ng-container *ngFor="let item of doctorPlans">
          <option value="{{item._id}}">{{item.name}}</option>
        </ng-container>
      </select>
    </div>
    <div class="col-md-12 mb-1"
      *ngIf="isEditEnabled && leadData.status !== 'APPROVED' && leadData.status !== 'REJECTED'">
      <label for="status_change" class="payingClinic col-md-6">Status Change:</label>
      <select name="status_change" class="form-control input-font name inputBox col-md-6" [(ngModel)]="status_change">
        <option value="AUTO">AUTO</option>
        <option value="MANUAL">MANUAL</option>
      </select>
    </div>
  </div>
</mat-dialog-content>
<mat-dialog-actions>
  <div class="ml-5" *ngIf="isEditEnabled && leadData.status !== 'APPROVED' && leadData.status !== 'REJECTED'">
    <button mat-button class="mat-raised-button  mr-4 btnWidth btn blankTurquoise"
      (click)="dialogRef.close(false)">Cancel</button>
    <button mat-button class="mat-raised-button mr-4 btn turquoiseBtn btnWidth" (click)="approveLead()">Approve</button>
    <!-- <button mat-button class="mat-raised-button btn rejectBtn btnWidth" (click)="rejectLead()">Reject</button> -->
  </div>
  <div class="ml-9" *ngIf="!(isEditEnabled && leadData.status !== 'APPROVED' && leadData.status !== 'REJECTED')">
    <button mat-button class="mat-raised-button  mr-4 btnWidth btn blankTurquoise"
      (click)="dialogRef.close(false)">Cancel</button>
  </div>
</mat-dialog-actions>
